import React from "react";

interface ChevronIconProps {
  color?: string;
  width?: number;
  height?: number;
  direction?: "down" | "up" | "left" | "right";
}

export const ChevronIcon: React.FC<ChevronIconProps> = ({
  color = "#7F869B",
  width = 9,
  height = 5,
  direction = "down",
}) => {
  const getRotation = () => {
    switch (direction) {
      case "up":
        return 180;
      case "left":
        return 90;
      case "right":
        return -90;
      default:
        return 0;
    }
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 9 5"
      fill="none"
      style={{ transform: `rotate(${getRotation()}deg)`, transition: "transform 0.2s ease" }}
    >
      <path d="M7.99984 1L4.5 4.5" stroke={color} strokeLinecap="round" />
      <path d="M1 1L4.49984 4.5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};
